import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
// Extends
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
// Models / Helpers
// Queries / Mutations
/**
 * More info "Question Mark" tooltip
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.21.0}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1856143582/Nested+Checkbox
 */
let MoreInfo = class MoreInfo extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.display = false;
    }
    get computedWidth() {
        if (this.lgAndUp) {
            return '35vw';
        }
        if (this.mdOnly) {
            return '50vw';
        }
        if (this.smOnly) {
            return '75vw';
        }
        return '95vw';
    }
    toggleDisplay() {
        this.display = !this.display;
    }
};
__decorate([
    Prop({ type: Boolean, default: null })
], MoreInfo.prototype, "clickable", void 0);
__decorate([
    Prop({ default: null })
], MoreInfo.prototype, "nudgeLeft", void 0);
__decorate([
    Prop({ default: null })
], MoreInfo.prototype, "nudgeRight", void 0);
MoreInfo = __decorate([
    Component
], MoreInfo);
export default MoreInfo;
